//1
const dateFormart=('dateFormart',function(value, formartStr){
    //根据传⼊的毫秒创建时间对象
    // 1.
    var date =new Date(value)
    //获取年⽉⽇
    // 2.
    var year = date.getFullYear()
    var month = date.getMonth()+1+''
    var day = date.getDate()+''
    var hours = date.getHours()+''
    var min = date.getMinutes()+''
    var sec = date.getSeconds()+''
    //判断需要格式化的格式
    // 3.
    if(formartStr && formartStr.toLowerCase()==='yyyy-mm-dd'){
    return`${year}-${month.padStart(2,'0')}-${day.padStart(2,'0')}`
    }elseif(formartStr && formartStr.toLowerCase()==='yy-mm-dd'),{
    }
    //⽣成指定的格式
    // 3.
    // return  year +"-"+month+"-"+day+" "+hours+":"+min+":"+sec;
    // return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")} ${hours.padStart(2, "0")}:${min.padStart(2, "0")}:${sec.padStart(2, "0")}`;
    })
    export default{
        dateFormart
    }



// WEBPACK FOOTER //
// ./src/dataday.js